import React, { useState } from 'react'

import { usePet } from '../../modules'

import Modal from "../resusable/modal"

const ApplyDiscount = ({ toggle, visible, order, onPerform, token }) => {
    const [discount, setDiscount] = useState()

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Discount has been applied', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('applyDiscountToBill', {
        bill: order?._id,
        discount,
        token
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Applying discount...' } })

    return (
        <Modal
            h="h-auto"
            w="w-1/4"
            title="Apply Discount"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        How much?
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-qty"
                        type="number"
                        onChange={ e => setDiscount(e.target.value)}
                        placeholder="Amount in Ksh" />
                </div>
            </div>
            <div className="flex justify-end">
                <button disabled={ loading } onClick={ execute } type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Apply Discount</button>
            </div>
        </Modal>
    )
}

export default ApplyDiscount